import { render } from "./Slideshow.vue?vue&type=template&id=396e9ae9&scoped=true&ts=true"
import script from "./Slideshow.vue?vue&type=script&lang=ts"
export * from "./Slideshow.vue?vue&type=script&lang=ts"

import "./Slideshow.vue?vue&type=style&index=0&id=396e9ae9&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396e9ae9"]])

export default __exports__